export default {
    queue_position: 'Position in queue: {{position}}',
    chat_closed: 'Chat Closed',
    waiting_agent: 'Awaiting service. Position {{position}}',
    error_send_message: 'There was a problem sending this message. Click Here To Try Again',
    message_action: {
        closed: 'Chat ended on {{date}} by {{name}}',
        queue_position: '<p class="m-0">Please wait for an agent to respond to your request.</p>' +
            'You are in the <b>position {{position}}</b> of the service queue.',
        agent_entered: '<b>{{name}}</b> joined the chat',
        transferred_agent: 'Chat transferred to<b>{{name}}</b>',
        created_ticket: 'Ticket <b>{{number}}</b> was opened from this chat',
    }
}
